// class AjaxCart {
//   constructor() {
//     this.bindEvents();
//   }

//   bindEvents() {
//     document.addEventListener('click', (e) => {
//       const button = e.target.closest('.ajax-add-to-cart');
//       if (!button) return;

//       e.preventDefault();
//       this.addToCart(button);
//     });
//   }

//   async addToCart(button) {
//     if (button.disabled) return;

//     const form = button.closest('form');
//     const formData = new FormData(form);

//     button.disabled = true;

//     try {
//       // 1️⃣ Add to cart
//       await fetch('/cart/add.js', {
//         method: 'POST',
//         body: formData
//       });

//       // 2️⃣ Fetch updated Dawn sections
//       const response = await fetch(
//         '/?sections=cart-drawer,header'
//       );
//       const sections = await response.json();

//       // =========================
//       // ✅ Update Cart Drawer
//       // =========================
//       const drawer = document.querySelector('cart-drawer');

//       if (drawer && sections['cart-drawer']) {
//         const parsedDrawer = new DOMParser()
//           .parseFromString(sections['cart-drawer'], 'text/html')
//           .querySelector('cart-drawer');

//         const newInner = parsedDrawer?.querySelector('.drawer__inner');
//         const currentInner = drawer.querySelector('.drawer__inner');

//         if (newInner && currentInner) {
//           currentInner.innerHTML = newInner.innerHTML;
//         }

//         drawer.classList.remove('is-empty');
//         drawer.open();
//       }

//       // =========================
//       // ✅ Update Header (Cart Icon + Bubble)
//       // =========================
//       if (sections['header']) {
//         const parsedHeader = new DOMParser()
//           .parseFromString(sections['header'], 'text/html')
//           .querySelector('header');

//         const currentHeader = document.querySelector('header');

//         if (parsedHeader && currentHeader) {
//           currentHeader.innerHTML = parsedHeader.innerHTML;
//         }
//       }

//     } catch (error) {
//       console.error('Ajax cart error:', error);
//     } finally {
//       button.disabled = false;
//     }
//   }
// }

// new AjaxCart();


// MINE Correct Original

// class AjaxCart {
//   constructor() {
//     this.bindEvents();
//   }

//   bindEvents() {
//     document.addEventListener('click', (e) => {
//       const button = e.target.closest('.ajax-add-to-cart');
//       if (!button) return;

//       e.preventDefault();
//       this.addToCart(button);
//     });
//   }

//   async addToCart(button) {
//     if (button.disabled) return;

//     const form = button.closest('form');
//     const formData = new FormData(form);

//     button.disabled = true;

//     try {
//       // 1️⃣ Add to cart
//       await fetch('/cart/add.js', {
//         method: 'POST',
//         body: formData
//       });

//       // 2️⃣ Fetch updated Dawn sections
//       const response = await fetch(
//         '/?sections=cart-drawer,header'
//       );
//       const sections = await response.json();

//       // =========================
//       // ✅ Update Cart Drawer
//       // =========================
//       const drawer = document.querySelector('cart-drawer');

//       if (drawer && sections['cart-drawer']) {
//         const parsedDrawer = new DOMParser()
//           .parseFromString(sections['cart-drawer'], 'text/html')
//           .querySelector('cart-drawer');

//         const newInner = parsedDrawer?.querySelector('.drawer__inner');
//         const currentInner = drawer.querySelector('.drawer__inner');

//         if (newInner && currentInner) {
//           currentInner.innerHTML = newInner.innerHTML;
//         }

//         drawer.classList.remove('is-empty');
//         drawer.open();
//       }

//       // =========================
//       // ✅ Update Header (Cart Icon + Bubble)
//       // =========================
//       if (sections['header']) {
//         const parsedHeader = new DOMParser()
//           .parseFromString(sections['header'], 'text/html')
//           .querySelector('header');

//         const currentHeader = document.querySelector('header');

//         if (sections['header']) {
//           const parsedHeader = new DOMParser()
//             .parseFromString(sections['header'], 'text/html');

//           const newBubble = parsedHeader.querySelector('#cart-icon-bubble');
//           const currentBubble = document.querySelector('#cart-icon-bubble');

//           if (newBubble && currentBubble) {
//             currentBubble.innerHTML = newBubble.innerHTML;
//           }
//         }
//       }

//     } catch (error) {
//       console.error('Ajax cart error:', error);
//     } finally {
//       button.disabled = false;
//     }
//   }
// }

// new AjaxCart();



/**
 * AjaxCart + DontForgetVariants
 * Handles:
 *  1. AJAX add-to-cart for .ajax-add-to-cart buttons
 *  2. Variant switching via color swatches in the "don't forget" block
 *     – Updates price, image, button state, and hidden variant ID without reload
 */



// Working without images
// class AjaxCart {
//   constructor() {
//     this.bindEvents();
//   }

//   bindEvents() {
//     document.addEventListener('click', (e) => {
//       const button = e.target.closest('.ajax-add-to-cart');
//       if (!button) return;
//       e.preventDefault();
//       this.addToCart(button);
//     });
//   }

//   async addToCart(button) {
//     if (button.disabled) return;

//     const form = button.closest('form');
//     const formData = new FormData(form);

//     button.disabled = true;
//     const btnText = button.querySelector('.btn-text');
//     const spinner = button.querySelector('.loading-spinner');
//     if (btnText) btnText.style.display = 'none';
//     if (spinner) spinner.style.display = 'inline-flex';

//     try {
//       await fetch('/cart/add.js', { method: 'POST', body: formData });

//       const response = await fetch('/?sections=cart-drawer,header');
//       const sections = await response.json();

//       // Update Cart Drawer
//       const drawer = document.querySelector('cart-drawer');
//       if (drawer && sections['cart-drawer']) {
//         const parsedDrawer = new DOMParser()
//           .parseFromString(sections['cart-drawer'], 'text/html')
//           .querySelector('cart-drawer');
//         const newInner = parsedDrawer?.querySelector('.drawer__inner');
//         const currentInner = drawer.querySelector('.drawer__inner');
//         if (newInner && currentInner) currentInner.innerHTML = newInner.innerHTML;
//         drawer.classList.remove('is-empty');
//         drawer.open();
//       }

//       // Update Header cart bubble
//       if (sections['header']) {
//         const parsedHeader = new DOMParser().parseFromString(sections['header'], 'text/html');
//         const newBubble = parsedHeader.querySelector('#cart-icon-bubble');
//         const currentBubble = document.querySelector('#cart-icon-bubble');
//         if (newBubble && currentBubble) currentBubble.innerHTML = newBubble.innerHTML;
//       }

//     } catch (error) {
//       console.error('Ajax cart error:', error);
//     } finally {
//       button.disabled = false;
//       if (btnText) btnText.style.display = '';
//       if (spinner) spinner.style.display = 'none';
//     }
//   }
// }


// class DontForgetVariants {
//   constructor() {
//     // Cache: productHandle -> variants array from Storefront JSON
//     this._cache = {};
//     this.bindEvents();
//   }

//   bindEvents() {
//     document.addEventListener('click', async (e) => {
//       const swatch = e.target.closest('.dont-forget-swatch');
//       if (!swatch) return;
//       e.preventDefault();

//       const variantId = swatch.dataset.variantId;
//       const productId = swatch.dataset.productId;
//       const productCard = swatch.closest('.dont-forget-product');
//       const swatchContainer = swatch.closest('.dont-forget-swatches');
//       const productHandle = swatchContainer?.dataset.productHandle;

//       if (!variantId || !productCard || !productHandle) return;

//       // Highlight active swatch immediately
//       swatchContainer.querySelectorAll('.dont-forget-swatch').forEach(s => s.classList.remove('active'));
//       swatch.classList.add('active');

//       // Add updating class for CSS transitions
//       productCard.classList.add('updating');

//       try {
//         const variants = await this.fetchVariants(productHandle);
//         const variant = variants.find(v => String(v.id) === String(variantId));
//         if (!variant) return;

//         this.updateCard(productCard, variant);
//       } catch (err) {
//         console.error('Variant fetch error:', err);
//       } finally {
//         productCard.classList.remove('updating');
//       }
//     });
//   }

//   /**
//    * Fetch all variants for a product via the Storefront JSON endpoint.
//    * Results are cached by product handle.
//    */
//   async fetchVariants(handle) {
//     if (this._cache[handle]) return this._cache[handle];

//     const res = await fetch(`/products/${handle}.js`);
//     if (!res.ok) throw new Error(`Failed to fetch product: ${handle}`);
//     const data = await res.json();

//     this._cache[handle] = data.variants;
//     return data.variants;
//   }

//   /**
//    * Update the product card DOM with the selected variant's data.
//    */
//   updateCard(card, variant) {
//     // --- Price ---
//     const priceContainer = card.querySelector('.dont-forget-product-prices');
//     if (priceContainer) {
//       const price = this.formatMoney(variant.price);
//       const comparePrice = variant.compare_at_price;

//       let html = '';
//       if (comparePrice && comparePrice > variant.price) {
//         html += `<span class="dont-forget-compare-price">${this.formatMoney(comparePrice)}</span>`;
//       }
//       html += `<span class="dont-forget-original-price">${price}</span>`;
//       priceContainer.innerHTML = html;
//     }

//     // --- Image ---
//     if (variant.featured_image) {
//       const img = card.querySelector('.dont-forget-img');
//       if (img) {
//         // Build a Shopify-sized URL
//         const src = this.shopifyImageUrl(variant.featured_image.src, '500x');
//         img.src = src;
//         img.alt = variant.featured_image.alt || variant.title;
//       }
//     }

//     // --- Hidden variant ID (for the add-to-cart form) ---
//     const hiddenInput = card.querySelector('.dont-forget-variant-id');
//     if (hiddenInput) hiddenInput.value = variant.id;

//     // --- Add button state ---
//     const btn = card.querySelector('.ajax-add-to-cart');
//     if (btn) {
//       btn.dataset.variantId = variant.id;
//       const btnText = btn.querySelector('.btn-text');
//       const available = variant.available;

//       if (btnText) {
//         btnText.textContent = available ? 'Add +' : 'Sold out';
//       }
//       btn.disabled = !available;
//     }

//     // --- Update card-level data attribute ---
//     card.dataset.variantId = variant.id;
//   }

//   /**
//    * Format cents → money string matching the store's currency format.
//    * Shopify exposes `Shopify.money_format` on the storefront.
//    */
//   formatMoney(cents) {
//     if (!cents && cents !== 0) return '';
//     const amount = (cents / 100).toFixed(2);

//     // Use Shopify's money_format if available
//     const format = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
//     return format.replace(/\{\{\s*amount\s*\}\}/, amount)
//                  .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
//                  .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
//                  .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, String(Math.round(cents / 100)).replace('.', ','));
//   }

//   /**
//    * Transform a Shopify image URL to a specific size.
//    * e.g. "//cdn.shopify.com/s/files/...image.jpg?v=123" → "...image_500x.jpg?v=123"
//    */
//   shopifyImageUrl(src, size) {
//     if (!src) return src;
//     // Make sure it has a protocol
//     const url = src.startsWith('//') ? `https:${src}` : src;
//     return url.replace(/(\.[a-z]+)(\?|$)/i, `_${size}$1$2`);
//   }
// }


// // Boot both classes
// new AjaxCart();
// new DontForgetVariants();










/**
 * AjaxCart + DontForgetVariants
 * Handles:
 *  1. AJAX add-to-cart for .ajax-add-to-cart buttons
 *  2. Variant switching via color swatches in the "don't forget" block
 *     – Updates price, image, button state, and hidden variant ID without reload
 */

class AjaxCart {
  constructor() {
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener('click', (e) => {
      const button = e.target.closest('.ajax-add-to-cart');
      if (!button) return;
      e.preventDefault();
      this.addToCart(button);
    });
  }

  async addToCart(button) {
    if (button.disabled) return;

    const form = button.closest('form');
    const formData = new FormData(form);

    button.disabled = true;
    const btnText = button.querySelector('.btn-text');
    const spinner = button.querySelector('.loading-spinner');
    if (btnText) btnText.style.display = 'none';
    if (spinner) spinner.style.display = 'inline-flex';

    try {
      await fetch('/cart/add.js', { method: 'POST', body: formData });

      const response = await fetch('/?sections=cart-drawer,header');
      const sections = await response.json();

      // Update Cart Drawer
      const drawer = document.querySelector('cart-drawer');
      if (drawer && sections['cart-drawer']) {
        const parsedDrawer = new DOMParser()
          .parseFromString(sections['cart-drawer'], 'text/html')
          .querySelector('cart-drawer');
        const newInner = parsedDrawer?.querySelector('.drawer__inner');
        const currentInner = drawer.querySelector('.drawer__inner');
        if (newInner && currentInner) currentInner.innerHTML = newInner.innerHTML;
        drawer.classList.remove('is-empty');
        drawer.open();
      }

      // Update Header cart bubble
      if (sections['header']) {
        const parsedHeader = new DOMParser().parseFromString(sections['header'], 'text/html');
        const newBubble = parsedHeader.querySelector('#cart-icon-bubble');
        const currentBubble = document.querySelector('#cart-icon-bubble');
        if (newBubble && currentBubble) currentBubble.innerHTML = newBubble.innerHTML;
      }

    } catch (error) {
      console.error('Ajax cart error:', error);
    } finally {
      button.disabled = false;
      if (btnText) btnText.style.display = '';
      if (spinner) spinner.style.display = 'none';
    }
  }
}


class DontForgetVariants {

  constructor() {
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener('click', (e) => {

      const swatch = e.target.closest('.dont-forget-swatch');
      if (!swatch) return;

      const card = swatch.closest('.dont-forget-product');
      const container = swatch.closest('.dont-forget-swatches');

      if (!card || !container) return;

      this.activateSwatch(container, swatch);
      this.updateCard(card, swatch);

    });
  }

  activateSwatch(container, swatch) {
    container.querySelectorAll('.dont-forget-swatch').forEach(btn => {
      btn.classList.remove('active');
    });

    swatch.classList.add('active');
  }

  updateCard(card, swatch) {

    const variantId = swatch.dataset.variantId;
    const price = swatch.dataset.price;
    const comparePrice = swatch.dataset.comparePrice;
    const available = swatch.dataset.available === "true";
    const image = swatch.dataset.image;

    // Update image
    const img = card.querySelector('.dont-forget-img');
    if (img && image) {
      img.src = image;
      img.srcset = '';
    }

    // Update price
    const priceContainer = card.querySelector('.dont-forget-product-prices');

    if (priceContainer) {

      let html = '';

      if (comparePrice && comparePrice > price) {
        html += `<span class="dont-forget-compare-price">${this.formatMoney(comparePrice)}</span>`;
      }

      html += `<span class="dont-forget-original-price">${this.formatMoney(price)}</span>`;

      priceContainer.innerHTML = html;
    }

    // Update form variant id
    const input = card.querySelector('.dont-forget-variant-id');
    if (input) input.value = variantId;

    // Update button
    const button = card.querySelector('.ajax-add-to-cart');

    if (button) {
      button.dataset.variantId = variantId;
      button.disabled = !available;

      const text = button.querySelector('.btn-text');
      if (text) text.textContent = available ? 'Add +' : 'Sold out';
    }

  }

  formatMoney(cents) {

    const amount = (cents / 100).toFixed(2);

    const format = (window.Shopify && window.Shopify.money_format) || '${{amount}}';

    return format.replace('{{amount}}', amount);
  }

}

new DontForgetVariants();


// Boot both classes
new AjaxCart();
new DontForgetVariants();